import { React } from 'react';
import styled from 'styled-components';


import TotalModalWrapper from '../../../Model/Share/Normal/TotalModalWrapper';
import { useLanguage } from '../../../Context/LanguageContext';

import SendMessageIcon from '../../../image/Send.png';

export default function SendCompleteModal(props) {
  const { text, onClickExit } = props;

  const { t } = useLanguage();

  return (
    <TotalModalWrapper>
      <ModalView>
        <RedTrashBoxWrapper>
          <EmptyButtonWrapper/>
          <RedTrashBox>
            <TrashImage src={SendMessageIcon} />
          </RedTrashBox>
          <EmptyButtonWrapper/>
          {/* <ExitButtonWrapper onClick={onClickExit}>
            <ExitImage src={ExitButtonIcon} />
          </ExitButtonWrapper> */}
        </RedTrashBoxWrapper>
        <TotalWrapper>
          <Title>{t('messageSend.completeModal.title')}</Title>
          <TextWrapper>
            <Explanation>{text}</Explanation>
            <Explanation>{t('messageSend.completeModal.message')}</Explanation>
          </TextWrapper>
        </TotalWrapper>
        <ButtonWrapper>
          <CompleteButton onClick={onClickExit}>{t('messageSend.completeModal.confirm')}</CompleteButton>
          {/* <NoButton onClick={onClickNoAdd}>추가 하지 않기</NoButton>
          <YesButton onClick={onClickAutoAdd}>추가하기</YesButton> */}
        </ButtonWrapper>
      </ModalView>
    </TotalModalWrapper>
  )
}

const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 354px;
  height: 200px;

  border-radius: 15px;
  box-shadow: 0px 40px 50px rgba(0, 0, 0, 0.1);
  background-color: #FFFFFF;
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  margin-top: 12px;

  width: 90.33%;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: #232323;

  margin: 0 0 0 0;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  
  justify-content: center;
  align-items: center;

  margin-top: 8px;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 12px;

  color: #595959;
  
  margin: 0 0 0 0;
`;

const RedTrashBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 12px 0px 12px;
  margin-top: -43px;

  width: calc(100% - 24px);
`;

const RedTrashBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  min-width: 86px;
  max-width: 86px;
  width: 86px;

  min-height: 86px;
  max-height: 86px;
  height: 86px;

  border-radius: 86px;
  background-color: #FF8B48;
`;

const TrashImage = styled.img`
  margin-left: -10px;

  width: 53px;
  height: 53px;
`;

const EmptyButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 12px;
  height: 12px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 28px;

  width: 100%;
  height: 52px;

  overflow: hidden;

  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
`;

const CompleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  background-color: #CFCFCF;
  
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: #6DD49E;
  }
`;
